module.exports = JBrowseExports["@jbrowse/core/ui/theme"];